<h2 id="contact">Contacteer onze helpdesk</h2>

<ng-container *ngIf="state === StatEnum.INITIAL || state === StatEnum.PROCESSING">
  <ng-container *ngTemplateOutlet="initial; context: { uiState: uiState.initial }"></ng-container>
</ng-container>

<ng-container *ngIf="state === StatEnum.SUCCESS">
  <ng-container *ngTemplateOutlet="feedback; context: { uiState: uiState.success }"></ng-container>
</ng-container>
<ng-container *ngIf="state === StatEnum.ERROR">
  <ng-container *ngTemplateOutlet="feedback; context: { uiState: uiState.error }"></ng-container>
</ng-container>

<ng-template #initial let-uiState="uiState">
  <div class="[ flex flex-wrap justify-center gap-m ]">
    <dcr-image src="assets/images/contact.png" class="illustration"></dcr-image>

    <form class="form [ flex flex-column flex-1 gap-m ]" [formGroup]="form" (ngSubmit)="submit()">
      <dcr-text-field label="Naam" formControlName="name"></dcr-text-field>
      <dcr-text-field label="School" formControlName="schoolName"></dcr-text-field>
      <dcr-text-field label="E-mailadres" type="email" formControlName="email"></dcr-text-field>
      <dcr-text-field label="Telefoonnummer" type="phone" formControlName="phone"></dcr-text-field>
      <dcr-select label="Onderwerp" formControlName="subject">
        <dcr-select-option *ngFor="let subject of subjects" [value]="subject" [label]="subject"></dcr-select-option>
      </dcr-select>
      <dcr-text-field label="Bericht" type="textarea" formControlName="message"></dcr-text-field>

      <dcr-filled-button
        type="submit"
        label="Versturen"
        [disabled]="!form.valid && state !== StatEnum.PROCESSING"
      ></dcr-filled-button>
    </form>
  </div>
</ng-template>

<ng-template #feedback let-uiState="uiState">
  <div>
    <div class="[ stack stack-space-m items-center ]">
      <campus-svg [svgImage]="uiState.img" class="[ w-full ]"></campus-svg>

      <h5>{{ uiState.header }}</h5>

      <div>
        <p class="[ text-center ]" *ngFor="let paragraph of uiState.description" [innerHTML]="paragraph"></p>
      </div>

      <dcr-filled-button *ngIf="state === StatEnum.SUCCESS" (click)="reset()" [label]="uiState.cta"></dcr-filled-button>
      <dcr-filled-button *ngIf="state === StatEnum.ERROR" (click)="submit()" [label]="uiState.cta"></dcr-filled-button>
    </div>
  </div>
</ng-template>
